export const sortFields = [
	'id',
	'materialId',
	'sku',
	'name',

	'materialCategoryId',
	'categoryRef',

	'priceUnitId',
	'priceUnit',
	'priceUnitRef',

	'stockStatus',
	'stockStatusRef',

	'materialTemplateId',
	'materialTemplateRef',

	'createdAt',
	'updatedAt',
] as const;
